import { intersection } from 'lodash-es';

import type { Keyword } from 'portlet/models';

export function compareKeywords(as: Keyword[], bs: Keyword[]): boolean {
    const formattedA = as.map(a => a.replace(/[^\w]/g, '').toLowerCase());
    const formattedB = bs.map(b => b.replace(/[^\w]/g, '').toLowerCase());

    return intersection(formattedA, formattedB).length > 0;
}
